export default "__VITE_ASSET__e06174d1__"